// extracted by mini-css-extract-plugin
export var wordContainer = "_ho-0";